/*
 * Trivzo GSAP bootstrap.
 *
 * GSAP + ScrollTrigger is roughly 110 KB. That is worth paying for exactly one
 * thing the platform still cannot do well: smooth scroll-linked motion. CSS
 * scroll-driven animations are not broadly supported yet, and IntersectionObserver
 * only fires on threshold crossings, so neither can drive a continuous parallax.
 *
 * Everything else on this theme (section reveals, card hover, stagger) is
 * already handled by Dawn's own `animations_reveal_on_scroll` and by
 * trivzo-motion.js. Running GSAP over those elements too would put two systems
 * on the same `transform` property, so it deliberately does not.
 *
 * The library is therefore only fetched when:
 *   1. the visitor has not asked for reduced motion, and
 *   2. this page actually contains a [data-tz-anim] element.
 *
 * Cart, checkout, search, and account pages have no such element, so they never
 * pay the download.
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var targets = document.querySelectorAll('[data-tz-anim]');
  if (!targets.length) return;

  // Coarse pointers are usually phones on metered connections, and a parallax
  // is the first thing to cut there.
  if (window.matchMedia('(max-width: 749px)').matches) return;

  var GSAP = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/index.js';
  var SCROLL_TRIGGER = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/ScrollTrigger.js';

  Promise.all([import(GSAP), import(SCROLL_TRIGGER)])
    .then(function (modules) {
      var gsap = modules[0].gsap;
      var ScrollTrigger = modules[1].ScrollTrigger;
      gsap.registerPlugin(ScrollTrigger);

      targets.forEach(function (el) {
        if (el.dataset.tzAnim !== 'hero-media') return;

        gsap.to(el, {
          yPercent: -9,
          ease: 'none',
          scrollTrigger: {
            trigger: el,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 0.6,
          },
        });
      });
    })
    .catch(function () {
      // A blocked or failed CDN fetch must not break the page. The hero simply
      // stays static, which is the correct fallback.
    });
})();
